import FestivalHero from "../common/hero";
import FestivalSteps from "./steps";
import FestivalBanner from "./banner";
import { PRODUCT_SLUG } from "@types";
import CardsSlider from "@features/landing/components/common/CardsSlider";
import homeApi from "@features/home/helpers/homeApi";
import { FESTIVAL_TYPE, FestivalProps } from "@features/landing/types";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";

import { useAppContext } from "@context/app";

const SpiralFestival: React.FC<FestivalProps> = ({ festivalData }) => {
  const festival = festivalData?.data.festival;
  const {
    user: { isLoggedIn },
  } = useAppContext();

  const theme = festival?.type || FESTIVAL_TYPE.WONDER;
  const expireTime = new Date(festival?.time_period.expire_at || "");
  const specialText = festival?.special_text || "";

  const { data: recommended } = useRequestImmutable(
    isLoggedIn
      ? homeApi.getHomeCards(PRODUCT_SLUG.USER_RECOMMENDED_PRODUCTS)
      : undefined
  );

  const { data: recentProduct } = useRequestImmutable(
    isLoggedIn
      ? homeApi.getHomeCards(PRODUCT_SLUG.USER_RECENT_VIEW_PRODUCT)
      : undefined
  );

  return (
    <div className="mb-16">
      <FestivalHero
        theme={theme}
        title=""
        expireDate={expireTime}
        specialText={specialText}
      />
      <FestivalSteps festivalData={festivalData} />
      {recommended?.data.products.length ? (
        <CardsSlider viewAllLink="/recommended-courses" {...recommended.data} />
      ) : null}
      <FestivalBanner />
      {recentProduct?.data.products.length ? (
        <CardsSlider viewAllLink="/recently-viewed" {...recentProduct.data} />
      ) : null}
    </div>
  );
};

export default SpiralFestival;
